import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const CancelPayslipDocumentProcessingJobApiService = async (
  request: number
): Promise<boolean> => {
  const uri = `/document_processing_jobs/${request}/cancel/`;
  const { data } = await axios.get(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCancelPayslipDocumentProcessingJobApiService = () =>
  useMutation<boolean, AxiosError, number>(
    "document_processing_jobs",
    CancelPayslipDocumentProcessingJobApiService
  );

export default useCancelPayslipDocumentProcessingJobApiService;
